// extracted by mini-css-extract-plugin
module.exports = {"expandListButton":"AccordionButton_expandListButton__aezvA","expandIcon":"AccordionButton_expandIcon__3BTee","expanded":"AccordionButton_expanded__3YEXK"};